import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=6c163aef&scoped=true&"
import script from "./ColorPicker.vue?vue&type=script&lang=js&"
export * from "./ColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=6c163aef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c163aef",
  null
  
)

export default component.exports